import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';

import ROUTES from '../../data/routes';


class CartImportErrors extends PureComponent {
  render() {
    const { totalAdded, errors = [] } = this.props;

    return (
      <div className="title-cart-import">
        <br />
        <br />
        <br />
        {!!totalAdded && (
          <div className="instructions-cart-import">
            <h4 style={{ color: 'black' }}>
              {I18n.t('noAggregatedProductsToCart', { 0: totalAdded })}
              &nbsp;
              <Link
                style={{ color: '#009FEC' }}
                to={ROUTES.CART}
                className="sorter-btn"
              >
                {I18n.t('goToCartNow')}
              </Link>
            </h4>
            <br />
          </div>
        )}
        {!!errors.length && (
          <div className="instructions-cart-import">
            <h5 style={{ color: 'red' }}>{`${I18n.t('dragAndDropCartErrorTitle')}:`}</h5>
            {errors.map((error, index) => (
              <p key={`${index}list`} style={{ color: 'black', fontSize: '14px', marginLeft: '20px' }}>
                {`${I18n.t('line')} ${error.line}: ${error.message}`}
              </p>
            ))}
          </div>
        )}
        {!totalAdded && !errors.length && (
          <div className="instructions-cart-import" style={{ textAlign: 'center' }}>
            <h5 style={{ color: 'red' }}>{I18n.t('UploadedEmpty')}</h5>
          </div>
        )}
      </div>
    );
  }
}

export default CartImportErrors;
